import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { LoginService, StaticFileHash } from '@scalefast/ecommerce-core';
import { of } from 'rxjs';

@Component({
  selector: 'app-login-button-template',
  styleUrls: ['./login-button-template.component.scss'],
  templateUrl: './login-button-template.component.html',
  standalone: true,
  imports: [AsyncPipe, StaticFileHash],
})
export class AppLoginButtonTemplateComponent {
  @Input() showAssociatedText = false;
  @Input() isUserLoggedIn = of(false);
  @Input() accountUrl = 'account';
  @Input() loginUrl = 'sso_login';
  @Input() signUpUrl = 'sso_signup';
  @Input() userName = of('userName');

  constructor(private loginService: LoginService) {}

  goToAccount(): void {
    /**
     * @FIXME Here we SHOULD use angular's router and navigate() method instead of window.location,
     * but because of the account page is hosted on v4 connection we need to reload the page, and we can't do that with angular router navigate.
     * Once the account page is hosted in v5 we need to make the switch to angular router navigate.
     */
    window.location.href = this.accountUrl;
  }

  goToLogin(): void {
    /**
     * @FIXME Here we SHOULD use angular's router and navigate() method instead of window.location,
     * but because of the login page is hosted on v4 connection we need to reload the page, and we can't do that with angular router navigate.
     * Once the login page is hosted in v5 we need to make the switch to angular router navigate.
     */
    window.location.href = this.loginUrl;
  }
  goToSignUp(): void {
    /**
     * @FIXME Here we SHOULD use angular's router and navigate() method instead of window.location,
     * but because of the login page is hosted on v4 connection we need to reload the page, and we can't do that with angular router navigate.
     * Once the login page is hosted in v5 we need to make the switch to angular router navigate.
     */
    window.location.href = this.signUpUrl;
  }

  goToV4(url: string): void {
    /**
     * @FIXME Here we SHOULD use angular's router and navigate() method instead of window.location,
     * but because of the account page is hosted on v4 connection we need to reload the page, and we can't do that with angular router navigate.
     * Once the account page is hosted in v5 we need to make the switch to angular router navigate.
     */
    window.location.href = url;
  }

  logoutV4() {
    sessionStorage.clear();
    location.reload();
  }
}
